import LocationDrawerCombo from '.';
import LocationDrawerComboBlockData from '@data/blocks/LocationDrawerComboBlockData';

const _map = (block: LocationDrawerComboBlockData) => {
  return <LocationDrawerCombo key={block._key} {...block} />;
};

export default _map;
